import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse } from '../types/api';

export interface ParentBlockSitter {
  id?: number;
  sitterId: number;
  parentId: number;
}

const URL = '/v2/blocked-sitters';

class ParentBlockSitterService {
  static create(
    data: Omit<ParentBlockSitter, 'id'>,
    config?: AxiosRequestConfig,
  ): Promise<DataResponse<ParentBlockSitter>> {
    return axios.post(URL, data, config);
  }

  static delete(id: number, config?: AxiosRequestConfig): Promise<unknown> {
    return axios.delete(`${URL}/${id}`, config);
  }
}

export { ParentBlockSitterService };
